import {
  ARCHITECTURAL_FEATURES,
  BATHROOM_DETAILS,
  BONUS_ROOMS,
  CABINET_STYLES,
  CEILING_HEIGHTS,
  CEILING_TYPES,
  COUNTERTOP_TYPES,
  FLOORING_TYPES,
  KITCHEN_DETAILS,
  KITCHEN_LAYOUTS,
  REGIONS,
  US_STATES,
  WALL_TYPES,
} from "./checklistOptions";

export const AGENT_RESPONSE_STEPS = [
  { path: "location", label: "Location & Lot", key: "locationLot" },
  { path: "exterior", label: "Exterior", key: "exterior" },
  { path: "interior", label: "Interior", key: "interior" },
  { path: "systems", label: "Systems", key: "systems" },
  { path: "condition", label: "Condition", key: "condition" },
  { path: "summary", label: "Agent Summary", key: "summary" },
];

export function agentResponsePath(id, stepPath, base = "/agent") {
  return `${base}/responses/${id}/${stepPath}`;
}

export const SETTING_OPTIONS = [
  { value: "urban", label: "Urban" },
  { value: "suburban", label: "Suburban" },
  { value: "rural", label: "Rural" },
];

export const LOT_TYPE_OPTIONS = [
  { value: "corner", label: "Corner" },
  { value: "cul-de-sac", label: "Cul-de-sac" },
  { value: "interior", label: "Interior lot" },
  { value: "view", label: "View lot" },
  { value: "acreage", label: "Acreage" },
];

export const YARD_SIZE_OPTIONS = [
  { value: "none", label: "Little to no yard" },
  { value: "small", label: "Small / low-maintenance" },
  { value: "medium", label: "Typical backyard" },
  { value: "large", label: "Large yard" },
  { value: "acreage", label: "Acreage" },
];

export const LANDSCAPING_OPTIONS = [
  { value: "low", label: "Low-maintenance" },
  { value: "established", label: "Established gardens" },
  { value: "blank", label: "Blank slate" },
  { value: "drought", label: "Drought-tolerant / xeriscape" },
];

export const FENCING_OPTIONS = [
  { value: "none", label: "None" },
  { value: "wood", label: "Wood privacy" },
  { value: "vinyl", label: "Vinyl" },
  { value: "iron", label: "Iron / view fence" },
  { value: "block", label: "Block / masonry" },
];

export const DRIVEWAY_OPTIONS = [
  { value: "straight", label: "Straight" },
  { value: "curved", label: "Curved" },
  { value: "long", label: "Long" },
  { value: "short", label: "Short" },
  { value: "circular", label: "Circular" },
];

export const GARAGE_OPTIONS = [
  { value: "none", label: "No garage" },
  { value: "1-car", label: "1-car" },
  { value: "2-car", label: "2-car" },
  { value: "3-car", label: "3-car+" },
  { value: "detached", label: "Detached" },
];

export const HOA_OPTIONS = [
  { value: "yes", label: "HOA" },
  { value: "no", label: "No HOA" },
  { value: "pud", label: "PUD / other" },
];

export const TERRAIN_OPTIONS = [
  { value: "level", label: "Level / usable" },
  { value: "slope", label: "Gentle slope" },
  { value: "steep", label: "Steep" },
  { value: "views", label: "Views" },
  { value: "privacy", label: "Private from neighbors" },
  { value: "drainage", label: "Strong drainage" },
  { value: "flood", label: "Flood-plain risk" },
  { value: "trees", label: "Mature trees" },
];

export const PORCH_OPTIONS = [
  { value: "covered", label: "Covered porch" },
  { value: "uncovered", label: "Uncovered porch" },
  { value: "wrap", label: "Wraparound" },
  { value: "none", label: "None" },
];

export const DECK_OPTIONS = [
  { value: "yes", label: "Deck present" },
  { value: "covered", label: "Covered deck" },
  { value: "none", label: "No deck" },
];

export const PATIO_OPTIONS = [
  { value: "none", label: "No patio" },
  { value: "small", label: "Small" },
  { value: "medium", label: "Medium" },
  { value: "large", label: "Large entertaining" },
  { value: "covered", label: "Covered patio" },
];

export const POOL_OPTIONS = [
  { value: "pool", label: "Swimming pool" },
  { value: "spa", label: "Spa / hot tub" },
  { value: "both", label: "Pool and spa" },
  { value: "none", label: "None" },
];

export const ROOF_OPTIONS = [
  { value: "composition", label: "Composition shingle" },
  { value: "tile", label: "Tile" },
  { value: "metal", label: "Metal" },
  { value: "slate", label: "Slate" },
  { value: "flat", label: "Flat / modern" },
];

export const SIDING_OPTIONS = [
  { value: "stucco", label: "Stucco" },
  { value: "fiber-cement", label: "Fiber cement" },
  { value: "wood", label: "Wood / shingle" },
  { value: "brick", label: "Brick" },
  { value: "stone", label: "Stone" },
  { value: "vinyl", label: "Vinyl" },
];

export const WINDOW_OPTIONS = [
  { value: "single-pane", label: "Single-pane" },
  { value: "dual-pane", label: "Dual-pane" },
  { value: "energy", label: "Energy-efficient / Low-E" },
  { value: "triple", label: "Triple-pane" },
  { value: "large", label: "Large / lots of glass" },
];

export const SOLAR_OPTIONS = [
  { value: "owned", label: "Owned solar" },
  { value: "leased", label: "Leased solar" },
  { value: "ready", label: "Solar-ready" },
  { value: "none", label: "None" },
];

export const HVAC_OPTIONS = [
  { value: "forced-air", label: "Forced air" },
  { value: "heat-pump", label: "Heat pump" },
  { value: "mini-split", label: "Mini-split / dual zone" },
  { value: "radiant", label: "Radiant" },
  { value: "boiler", label: "Boiler" },
  { value: "window-units", label: "Window units only" },
];

export const HEATING_OPTIONS = [
  { value: "gas", label: "Gas" },
  { value: "electric", label: "Electric" },
  { value: "heat-pump", label: "Heat pump" },
  { value: "propane", label: "Propane" },
  { value: "oil", label: "Oil" },
  { value: "none", label: "None / unknown" },
];

export const COOLING_OPTIONS = [
  { value: "central", label: "Central air" },
  { value: "heat-pump", label: "Heat pump" },
  { value: "mini-split", label: "Mini-split" },
  { value: "evaporative", label: "Evaporative / swamp" },
  { value: "none", label: "No cooling" },
];

export const ELECTRICAL_OPTIONS = [
  { value: "updated", label: "Updated panel" },
  { value: "200-amp", label: "200-amp service" },
  { value: "100-amp", label: "100-amp service" },
  { value: "older", label: "Older / unknown" },
];

export const PLUMBING_OPTIONS = [
  { value: "copper", label: "Copper" },
  { value: "pex", label: "PEX" },
  { value: "galvanized", label: "Galvanized (aging)" },
  { value: "mixed", label: "Mixed" },
  { value: "unknown", label: "Unknown" },
];

export const WATER_HEATER_OPTIONS = [
  { value: "tank", label: "Tank" },
  { value: "tankless", label: "Tankless" },
  { value: "hybrid", label: "Hybrid / heat pump" },
  { value: "unknown", label: "Unknown" },
];

export const SEWER_OPTIONS = [
  { value: "city", label: "City sewer" },
  { value: "septic", label: "Septic" },
  { value: "unknown", label: "Unknown" },
];

export const INTERNET_OPTIONS = [
  { value: "fiber", label: "Fiber" },
  { value: "cable", label: "Cable" },
  { value: "dsl", label: "DSL" },
  { value: "fixed-wireless", label: "Fixed wireless" },
  { value: "unknown", label: "Unknown / confirm" },
];

export const SMART_HOME_OPTIONS = [
  { value: "thermostat", label: "Smart thermostat" },
  { value: "locks", label: "Smart locks" },
  { value: "cameras", label: "Cameras / doorbell" },
  { value: "lighting", label: "Smart lighting" },
  { value: "speakers", label: "Whole-home audio" },
  { value: "none", label: "None noted" },
];

export const ENERGY_OPTIONS = [
  { value: "solar", label: "Solar" },
  { value: "battery", label: "Battery backup" },
  { value: "insulation", label: "Upgraded insulation" },
  { value: "windows", label: "Efficient windows" },
  { value: "none", label: "No upgrades noted" },
];

export const CONDITION_OPTIONS = [
  { value: "excellent", label: "Excellent / move-in ready" },
  { value: "good", label: "Good / light cosmetic" },
  { value: "average", label: "Average / dated but sound" },
  { value: "needs-work", label: "Needs work" },
  { value: "fixer", label: "Fixer / major systems" },
];

export const UPDATE_OPTIONS = [
  { value: "kitchen", label: "Kitchen updated" },
  { value: "baths", label: "Baths updated" },
  { value: "floors", label: "Floors updated" },
  { value: "roof", label: "Roof replaced" },
  { value: "hvac", label: "HVAC replaced" },
  { value: "windows", label: "Windows replaced" },
  { value: "electrical", label: "Electrical updated" },
  { value: "plumbing", label: "Plumbing updated" },
];

export const INSPECTION_FLAGS = [
  { value: "roof", label: "Roof concern" },
  { value: "foundation", label: "Foundation / settlement" },
  { value: "moisture", label: "Moisture / drainage" },
  { value: "hvac", label: "HVAC age / function" },
  { value: "electrical", label: "Electrical" },
  { value: "plumbing", label: "Plumbing" },
  { value: "pests", label: "Pests" },
  { value: "hoa", label: "HOA / rental limits" },
  { value: "none", label: "None flagged yet" },
];

export const RECOMMENDATION_OPTIONS = [
  { value: "strong-match", label: "Strong match — write it" },
  { value: "show-again", label: "Worth a second look" },
  { value: "backup", label: "Backup / watch list" },
  { value: "pass", label: "Pass — does not fit" },
];

export const AGE_BANDS = [
  { value: "0-5", label: "0–5 years" },
  { value: "6-10", label: "6–10 years" },
  { value: "11-20", label: "11–20 years" },
  { value: "20+", label: "20+ years" },
  { value: "unknown", label: "Unknown" },
];

export {
  ARCHITECTURAL_FEATURES,
  BATHROOM_DETAILS,
  BONUS_ROOMS,
  CABINET_STYLES,
  CEILING_HEIGHTS,
  CEILING_TYPES,
  COUNTERTOP_TYPES,
  FLOORING_TYPES,
  KITCHEN_DETAILS,
  KITCHEN_LAYOUTS,
  REGIONS,
  US_STATES,
  WALL_TYPES,
};
